import { useMemo } from 'react';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import UserPlan from '@creditflowresearch/user-plan/UserPlan';
import CorpSegment from '@/creditflowresearch/domain/Segment/entities/CorpSegment';
import FigSegment from '@/creditflowresearch/domain/Segment/entities/FigSegment';
import SsaSegment from '@/creditflowresearch/domain/Segment/entities/SsaSegment';
import { useAccessGrant } from '@/creditflowresearch/application/User/access/grants/useAccessGrant';

export interface ISegmentFilter {
  id: string,
  abbreviation: string,
  queryName?: string,
  disabled?: boolean,
  tooltip?: React.ReactNode,
}

export const useCreateSegmentFilters = (): ISegmentFilter[] => {
  const { plan } = useUserPlanContext();
  const granted = useAccessGrant();

  return useMemo<ISegmentFilter[]>(() => {
    return [
      {
        id: CorpSegment.SEGMENT_ID,
        abbreviation: CorpSegment.TYPE,
        queryName: CorpSegment.TYPE,
        disabled: !granted && !UserPlan.isSatisfiedPremiumPlan(plan),
        tooltip: 'Corporate',
      },
      {
        id: FigSegment.SEGMENT_ID,
        abbreviation: FigSegment.TYPE,
        queryName: FigSegment.TYPE,
        disabled: !granted && !UserPlan.isSatisfiedPremiumPlan(plan),
        tooltip: 'Financial Institutions Group',
      },
      {
        id: SsaSegment.SEGMENT_ID,
        abbreviation: SsaSegment.TYPE,
        queryName: SsaSegment.TYPE,
        disabled: !granted && !UserPlan.isSatisfiedPremiumPlan(plan),
        tooltip: 'Sovereign, Supranational & Agency',
      },
    ];
  }, [plan, granted]);
};
